let _registrationSettings: IRegistrationSettings;
export interface IRegistrationSettings {
  zipCode: string;
  registrationType: number;
}

export const RegistrationSettingsService = {
  get(): IRegistrationSettings {
    return _registrationSettings;
  },
  set(value: IRegistrationSettings): void {
    _registrationSettings = value;
  },
};
